// extracted by mini-css-extract-plugin
export default {"wrapper":"privacy-page_wrapper__SWc5A","privacy":"privacy-page_privacy__kOHTa","title":"privacy-page_title__CICye","subtitle":"privacy-page_subtitle__BD8dd"};